<template>
    <span class="d-flex align-center ga-2">
      	<v-icon :icon="icon" color="primary" class="mr-2" />
    	<span>{{ typeValue }}</span>
    </span>
</template>

<script setup>
  import { inject, onBeforeMount, ref } from 'vue';
  import { mdiFormatTitle, mdiNumeric, mdiToggleSwitchOutline, mdiFormatListBulleted, mdiFormatListChecks, mdiCalendarMonthOutline, mdiCurrencyEur} from '@mdi/js';

  const props = defineProps(['params']);

  const translate = inject('translate');

  const attributeType = Object.freeze([{
      "id": 0,
      "value": "None"
    },
    {
      "id": 1,
      "value": "String",
      "icon": mdiFormatTitle
    },
    {
      "id": 2,
      "value": "Int",
      "icon": mdiNumeric
    },
    {
      "id": 3,
      "value": "Boolean",
      "icon": mdiToggleSwitchOutline
    },
    {
      "id": 4,
      "value": "OpenList",
      "icon": mdiFormatListBulleted
    },
    {
      "id": 5,
      "value": "OpenListMultiple",
      "icon": mdiFormatListChecks
    },
    {
      "id": 8,
      "value": "DateTime",
      "icon": mdiCalendarMonthOutline
    },
    {
      "id": 9,
      "value": "Money",
      "icon": mdiCurrencyEur
    },
    {
      "id": 10,
      "value": "Decimal",
      "icon": mdiNumeric
    }]);

  const typeValue = ref('');
  const types = ref([]);
  const icon = ref('');

  onBeforeMount(() => {
    types.value = attributeType;

    if (typeof props.params.value != 'undefined') {
        let originalValue = props.params.value;

        if (types.value.filter(t => t.id == parseInt(originalValue)).length > 0) {
            let type = types.value.filter(t => t.id == parseInt(originalValue)).first();

            typeValue.value = translate(type.value.toLowerCase(), 'varType');
            icon.value = type.icon;
        }
        else
            typeValue.value = props.params.value;
    }
  })

</script>
